<template>
    <div v-if="country.name" class="quick-links">
        <div>
                <img :alt="country.name + ' Flag'" :data-src="country.flag_verified"
                    class="country-flag lazyload" height="16" width="16">
                <p class="title text-base font-semibold inline-block">
                    Explore by Category:
                  <a :href="country.path" class="text-black">
                    <span class="text-[#0157ff] hover:underline">
                        {{ country.name }}
                    </span>
                  </a>
                </p>
                <p class="date font-size-12 font-weight-400 inline-block">{{ time }}</p>
        </div>

        <div class="flex flex-wrap">
            <div v-for="(link, index) in links"
                 :class="(index % 2 === 0? 'sm:pr-[10px] ':'sm:pl-[10px] ') + ' w-full sm:w-1/2'">
                <div class="card flex justify-center bg-clip-border bg-white border rounded flex flex-col min-w-0 relative border-solid border-[rgba(0,0,0,0.125)] hover:shadow">
                    <a :href="link.url" class="flex items-center text-decoration-none" data-gtm="quick-links">
                        <img :alt="link.name" :data-src="link.icon" class="icon lazyload">
                        <span class="text-base font-bold text-left ml-2 text-black overflow-auto">
                            {{ link.name }}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HeaderQuickLinks",
    data() {
        return {
            time: '',
            links: [],
            country: {},
        };
    },
    mounted() {
        this.fetchLinks();
        this.displayUserCurrentTime();
    },
    methods: {
        visitorCountryCode() {
            if (!$('html').data('ipcountry')) {
                return 'gb';
            }
            return $('html').data('ipcountry').toLowerCase();
        },

        displayUserCurrentTime() {
            let d = new Date();
            let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

            this.time = days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear() + ' - ' + this.addZeroBeforeDigit(d.getHours()) + ':' + this.addZeroBeforeDigit(d.getMinutes()) + ':' + this.addZeroBeforeDigit(d.getSeconds());
        },

        addZeroBeforeDigit(value) {
            return ("0" + value).slice(-2);
        },

        fetchLinks() {
            axios
                .get('/json-files/header-quick-links.json')
                .then((response) => {
                    // find the country
                    let visitorCountryCode = this.visitorCountryCode();

                    // find the current country
                    this.country = response.data['countries'].find(function (country) {
                        return country['code'] === visitorCountryCode;
                    }, visitorCountryCode);

                    // when not found - we need to fallback to uk/gb
                    let optlistCountry = this.country;
                    if (!this.country) {
                        this.country = response.data['countries'].find(function (country) {
                            return country['code'] === 'gb';
                        });

                        // show the global flag
                        optlistCountry = {
                            'name': 'Global',
                            'flag_verified': 'https://objects.kaxmedia.com/auto/o/133832/dc78f85d36.svg',
                        };
                    }

                    this.links = this.country['links'];

                    this.updateOptListCountry(optlistCountry);
                })
                .catch((error) => {
                    console.log('--------------- error ---------------');
                });
        },

        updateOptListCountry(country) {
            let countryBox = $('div[data-js="country-box"]');
            if (countryBox) {
                let countryName = country.name;
                let countryFlag = country.flag_verified;

                if (this.visitorCountryCode() === 'za') {
                    countryName = 'South Africa';
                    countryFlag = 'https://objects.kaxmedia.com/auto/o/107276/0b68181797.svg';
                }
                if (this.visitorCountryCode() === 'in') {
                    countryName = 'India';
                    countryFlag = 'https://objects.kaxmedia.com/auto/o/107273/0122188cd6.svg';
                }

                countryBox.find('[data-js="country-name"]').html(countryName);
                countryBox.find('img').attr('alt', countryName);
                countryBox.find('img').attr('src', countryFlag);
            }
        }
    }
}
</script>
